import * as moment from 'moment-timezone';
import { ClickService } from 'src/app/services/click.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { Subscription, take, timer } from 'rxjs';
import Highcharts from 'highcharts';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import { LONG_RANGE_POINTS, sharedPriceTooltipFormatter } from 'src/app/modules/gasprecio/utils/evolutionChartLib';

@Component({
  selector: 'app-evolution-chart-panel',
  templateUrl: './evolution-chart-panel.component.html',
  styleUrls: ['./evolution-chart-panel.component.scss']
})
export class EvolutionChartPanelComponent implements OnInit, OnDestroy {

  @Input() productType = 'regular';
  modalRef?: BsModalRef;
  data: any;
  date: any;
  daysAgo = 30;
  daysAgo$!: Subscription;
  dataPeriod = 'current';
  id: any;
  idStation: any;
  idGroup = '60afa99655f4ee369d1df409';
  lastDate = moment().format('YYYY-MM-DD');
  max = moment().format('YYYY-MM-DD');
  forkJoinEvolution: any;
  priceReport: any;
  productType$!: Subscription;
  reqst = 1;
  reqstM = 0;
  rol;
  startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
  type = 'price';
  levelDiscount = '9';
  levelDiscount$!: Subscription;
  levelIncrement = '1';
  levelIncrement$!: Subscription;
  showFilter = false;
  showRuta = false;
  stationsList = [];
  stationName = '';
  period = 'day';
  period$: Subscription;
  months = 12;
  months$: Subscription;
  weeks = 12;
  weeks$: Subscription;

  rotateSub?: Subscription;
  idx = 0;
  updateFlag;
  reqSeq = 0;
  cache = new Map<string, any>();
  updateFlag0 = false;
  updateFlag1 = false;
  activeBuf = 0

  Highcharts: typeof Highcharts = Highcharts;
  generalOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      text: `Histórico - Evolución de Precios`,
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
    },
    yAxis: [
      {
        title: {
          text: 'Precio de Venta',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '$ {value:.2f}'
        },
        tickAmount: 10,
        gridLineDashStyle: 'LongDash',
        opposite: false,
      },
      {
        title: {
          text: 'Ventas',
          style: {
            fontSize: '0'
          }
        },
        opposite: true,
        tickAmount: 10,
        gridLineDashStyle: 'LongDash',
        labels: {
          format: '{value:,.0f} lts.'
        }
      }
    ],
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      width: 450,
      itemWidth: 100,
      itemHoverStyle: {
        color: '#00E07B',
      },
      itemStyle: {
        fontSize: '10px',
        color: '#333333'
      },
    },
    tooltip: {
      split: true
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 3
        },
        lineWidth: 1
      }
    },
    exporting: {
      filename: `Histórico - Evolución de Precios`,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -6
      }
    },
    series: []
  }
  chartOptions0: Highcharts.Options = Highcharts.merge({}, this.generalOptions);
  chartOptions1: Highcharts.Options = Highcharts.merge({}, this.generalOptions);


  constructor(
    private gasprecioService: GasprecioService,
    public clickService: ClickService,
    private sharedService: SharedService
  ) {
    this.rol = localStorage.getItem('rol');
    this.idStation = localStorage.getItem('idStation');
    this.id = localStorage.getItem('id');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.showRuta = this.idGroup === '668eb65057ab5f397ef9f2df' ? true : false;
    this.productType$ = this.sharedService.sharedProductType.subscribe(productType => {
      if (this.productType === productType) {
        return;
      }
      this.productType = productType;
      if (this.reqst > 1) {
        this.startRotation();
      }
    });
    this.daysAgo$ = this.sharedService.sharedDaysEvolution.subscribe(daysAgo => {
      if (this.daysAgo === daysAgo) {
        return;
      }
      this.daysAgo = daysAgo;
      this.cache.clear();
      this.data = [];
      if (this.reqst > 1) {
        this.reqst = 1;
        this.startRotation();
      }
    });

    this.levelDiscount$ = this.sharedService.sharedLevelDiscount.subscribe(levelDiscount => {
      if (this.levelDiscount === levelDiscount) {
        return;
      }
      this.levelDiscount = levelDiscount;
      if (this.reqst > 1) {
        this.startRotation();
      }
    });

    this.levelIncrement$ = this.sharedService.sharedLevelIncrement.subscribe(levelIncrement => {
      if (this.levelIncrement === levelIncrement) {
        return;
      }
      this.levelIncrement = levelIncrement;
      if (this.reqst > 1) {
        this.startRotation();
      }
    });

    this.period$ = this.sharedService.sharedPeriodDashboard.subscribe(period => {
      if (period !== this.period) {
        this.period = period;
        if (this.reqst > 1) this.startRotation();
      }
    });

    this.weeks$ = this.sharedService.sharedWeeksAgo.subscribe(weeks => {
      if (weeks !== this.weeks) {
        this.weeks = weeks;
        if (this.reqst > 1) {
          this.startRotation();
        }
      }
    });

    this.months$ = this.sharedService.sharedMonthsAgo.subscribe(months => {
      if (months !== this.months) {
        this.months = months;
        if (this.reqst > 1) {
          this.startRotation();
        }
      }
    });
  }

  ngOnInit(): void {
    this.getStationsGroup()
  }

  ngOnDestroy(): void {
    this.productType$.unsubscribe();
    this.daysAgo$.unsubscribe();
    this.levelDiscount$.unsubscribe();
    this.levelIncrement$.unsubscribe();
    this.period$.unsubscribe();
    this.months$.unsubscribe();
    this.weeks$.unsubscribe();
    this.rotateSub?.unsubscribe();
  }

  getEvolution() {
    this.reqst = 1;
    this.reqstM = 1;
    const month = this.daysAgo === 0 ? 'previous' : this.daysAgo === 99 ? 'current' : null;
    let n!: number;
    if (this.period === 'day') n = this.daysAgo;
    else if (this.period === 'week') n = this.weeks;
    else n = this.months;
    const priceHistory = month ? this.gasprecioService.getPriceHistory(n, month, this.period) : this.gasprecioService.getPriceHistory(n, null, this.period);
    priceHistory.subscribe({
      next: (data) => {
        this.data = data;
        this.stationName = data?.client?.name
        this.setData('data');
      }, complete: () => {
        this.reqst = 2;
      }
    });
  }

  setData(dataType: string, targetBuffer?: 0 | 1) {
    if (dataType === 'data') {
      this.reqst = 1;
    } else {
      this.reqstM = 1;
    }

    // Con rangos largos los marcadores se enciman y la animación retrasa el dibujado.
    const longRange = this[dataType]['client']['values'].length > LONG_RANGE_POINTS;

    let nameStation;
     if (this.rol === 'Gaspre') {
      nameStation = 'Tu Estación ' + ' (' + this[dataType]['client']['brand'] + ')'
    } else {
      nameStation = this[dataType]['client']['name'] + ' (' + this[dataType]['client']['brand'] + ')';
    }

    const lineChartData: any = [
      {
        name: nameStation,
        data: this[dataType]['client']['values'].map((v: any) => {
          if (v[this.productType] === null || +v[this.productType] < -7) {
            return null;
          } else {
            return +v[this.productType].toFixed(2);
          }
        }),
        color: 'rgb(212, 175, 55)',
        lineWidth: 1.5,
        zIndex: 2,
        marker: {
          enabled: !longRange,
          radius: 3
        },
        tooltip: {
          formatter: sharedPriceTooltipFormatter
        }
      }
    ]

    const lineXaxisLegend: any = [];
    this[dataType]['client']['values'].map((v: any) =>{
      if(this.period === 'day'){
        lineXaxisLegend.push(this.gasprecioService.parseDateDM(v['date']))
      }else if(this.period === 'week'){
        lineXaxisLegend.push(v['date_alias'])
      }else{
        lineXaxisLegend.push(this.gasprecioService.parseDateM(v['date']))
      }

    });

    this[dataType]['competitors'].forEach((c, index) => {
      let nameCompetitor;
      if (this.rol === 'Gaspre') {
        nameCompetitor = 'Competitor ' + (index + 1) + ' (' + c['brand'] + ')'
      } else {
        nameCompetitor = c['name'] + ' (' + c['brand'] + ')';
      }
      let color = `rgb(${this.gasprecioService.colors[index + 1].r}, ${this.gasprecioService.colors[index + 1].g}, ${this.gasprecioService.colors[index + 1].b})`;
      lineChartData.push({
        name: nameCompetitor,
        data: c['values'].map((v: any) => {
          if (v[this.productType] === null || +v[this.productType] < -7 || v[this.productType] === undefined) {
            return null; // Devuelve null si el valor es null
          } else {
            return +v[this.productType].toFixed(2); // Devuelve el valor convertido a número
          }
        }),
        color: color,
        zIndex: 1,
        tooltip: {
          formatter: sharedPriceTooltipFormatter
        }
      });
    });
    // Se mide sobre las etiquetas que se van a pintar, no sobre el buffer previo:
    // con rangos largos el borde de las columnas las vuelve una mancha sólida.
    const numberLabels = lineXaxisLegend.length;
    const borderW = numberLabels >= 90 ? 0 : 2;
    const products = ['regular', 'premium', 'diesel'];
    const indexProductType = products.findIndex((p) => p === this.productType);
    const selectedColor = this.gasprecioService.colorsProductsLight[indexProductType];
    // Ventas en el tono claro del producto y Tendencia en el sólido. MOBICO usa su
    // propia gama (la del flujo de pipas), no la estándar de GASPRE.
    const mobicoColors: Record<string, { base: string; faded: string }> = {
      regular: { base: '#0033a0', faded: 'rgba(0, 51, 160, .35)' },
      premium: { base: '#c8102e', faded: 'rgba(200, 16, 46, .35)' },
      diesel: { base: '#3f4750', faded: 'rgba(63, 71, 80, .35)' },
    };
    const isMobico = this.idGroup === '6697df2bfb7789085d7d82b4';
    const mobicoColor = isMobico ? mobicoColors[this.productType] : undefined;
    const productColor = mobicoColor ? mobicoColor.faded : `rgba(${selectedColor.r}, ${selectedColor.g}, ${selectedColor.b}, ${selectedColor.a})`;
    const trendColor = mobicoColor
      ? mobicoColor.base
      : this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[indexProductType]);
    const salesGraph = {
      name: 'Ventas',
      type: 'column',
      data: this[dataType]['client']['sales']?.map((s) => s[this.productType] === null ? null : +s[this.productType]),
      color: productColor,
      borderColor: productColor,
      borderWidth: borderW,
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return '<b>' + this.series.name + ': ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.</b>';
        }
      }
    };
    const adjustedSales = {
      name: 'Tendencia',
      type: 'line',
      data: this[dataType]['client']['adjustedSales']?.map((s) => s[this.productType] === null ? null : +s[this.productType]),
      color: trendColor,
      borderColor: trendColor,
      lineWidth: 3,
      dashStyle: 'ShortDashDot',
      marker: {
        radius: 1
      },
      yAxis: 1,
      tooltip: {
        pointFormatter: function () {
          return '<b>' + this.series.name + ': ' + this.y.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' lts.</b>';
        }
      }
    };

    const target = (targetBuffer ?? ((this.activeBuf ^ 1) as 0 | 1));
    const base = target === 0 ? this.chartOptions0 : this.chartOptions1;

    const nextOptions: Highcharts.Options = {
      ...base,
      xAxis: { ...(base.xAxis as Highcharts.XAxisOptions), categories: lineXaxisLegend },
      plotOptions: {
        ...base.plotOptions,
        series: {
          ...base.plotOptions?.series,
          animation: longRange ? false : { duration: 1000 },
          marker: { enabled: !longRange, radius: 3 }
        }
      },
      series: [...lineChartData, salesGraph, adjustedSales]
    };

    if (target === 0) {
      this.chartOptions0 = nextOptions;
      this.updateFlag0 = true;
    } else {
      this.chartOptions1 = nextOptions;
      this.updateFlag1 = true;
    }

    setTimeout(() => {
      if (dataType === 'data') this.reqst = 2; else this.reqstM = 2;
    }, 100);
  }

  clickPage() {
    this.clickService.clickPage(this.id, this.idStation, 'Descargar', 'GasPrecio')
      .pipe()
      .subscribe(
        data => {
        });
  }

  showStation(idStation: string) {
    const cached = this.cache.get(idStation);
    const back: 0 | 1 = (this.activeBuf ^ 1) as 0 | 1;

    if (cached) {
      this.data = cached;
      this.stationName = cached?.client?.name;
      this.setData('data', back);
      setTimeout(() => { this.activeBuf = back; }, 0);
      this.reqst = 2;
      return;
    }

    if (!this.data) this.reqst = 1;

    this.getPriceHistoryFor(idStation).pipe(take(1)).subscribe({
      next: (data) => {
        this.cache.set(idStation, data);
        this.data = data;
        this.stationName = data?.client?.name;
        this.setData('data', back);
        setTimeout(() => { this.activeBuf = back; }, 0);
        this.reqst = 2;
      },
      error: () => { if (!this.data) this.reqst = 3; }
    });
  }

  prefetchNext() {
    const nextIdx = (this.idx + 1) % this.stationsList.length;
    const nextId = this.stationsList[nextIdx].value;
    if (this.cache.has(nextId)) return;

    this.getPriceHistoryFor(nextId).pipe(take(1)).subscribe({
      next: (data) => this.cache.set(nextId, data),
      error: () => {
        console.log("error al obtener la info")
      }
    });
  }

  getPriceHistoryFor(idStation: string) {
    const month = this.daysAgo === 0 ? 'previous' : this.daysAgo === 99 ? 'current' : null;
    const n = this.period === 'day' ? this.daysAgo
          : this.period === 'week' ? this.weeks
          : this.months;
    return this.gasprecioService.getPriceHistory(n, month, this.period, idStation);
  }

  startRotation() {
    this.showStation(this.stationsList[this.idx].value);
    this.prefetchNext();

    this.rotateSub?.unsubscribe();
    this.rotateSub = timer(60000, 60000).subscribe(() => {
      if (document.hidden) return;
      this.idx = (this.idx + 1) % this.stationsList.length;
      const id = this.stationsList[this.idx].value;
      this.showStation(id);
      this.prefetchNext();
    });
  }
  getStationsGroup() {
    this.stationsList = [];
    this.gasprecioService.getStationsGroup(this.idGroup).subscribe({
      next: (data)=> {
        const stations: any = data;
        stations.forEach((element: any) => {
          this.stationsList.push({ name: element.alias, value: element._id });
        });
        this.stationsList.sort((a, b) => {
          if (a.value === this.idStation) return -1;
          if (b.value === this.idStation) return 1;
          return 0;
        });
      },
      complete: () => {
        this.startRotation();
      }
    })

  }
}


